import Icon from 'components/shared/Icon'
import { SliderNextButton, SliderPrevButton } from './styles'

type SliderButtonProps = {
    direction: 'prev' | 'next'
    onClick: (scrollStep: number) => void
}
export const SliderButton = ({ direction, onClick }: SliderButtonProps) => {
    const isPrev = direction === 'prev'
    const scrollStep = 200
    const ButtonComponent = isPrev ? SliderPrevButton : SliderNextButton
    return (
        <ButtonComponent
            as="button"
            onClick={() => onClick(isPrev ? -scrollStep : scrollStep)}
        >
            <Icon
                variant="arrow"
                color="primary_500"
                rotation={isPrev ? 180 : 0}
            />
        </ButtonComponent>
    )
}
